import React, { useEffect, useState } from "react";
import { Phone, Mail, MapPin, Instagram } from "lucide-react";
import api from "@/lib/api";

const Contact = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)); }, []);

  return (
    <div className="mx-auto max-w-4xl px-5 sm:px-8 py-14 sm:py-20">
      <div className="text-center mb-12">
        <p className="text-goldsoft text-xs uppercase tracking-[0.3em] mb-2">Say Hello</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-choco">Get in Touch</h1>
        <p className="text-muted-foreground mt-3">We'd love to hear from you. Reach us through any of the channels below.</p>
      </div>

      {s && (
        <div className="grid sm:grid-cols-2 gap-5">
          <a href={`tel:${s.contact_phone}`} className="bg-white rounded-2xl border border-[#EFEBE1] p-6 flex items-center gap-4 hover:-translate-y-1 hover:shadow-lg transition-[transform,box-shadow]">
            <div className="h-12 w-12 rounded-full bg-mutedcream flex items-center justify-center text-goldsoft"><Phone size={22} /></div>
            <div><p className="text-sm text-muted-foreground">Call us</p><p className="font-semibold text-choco">{s.contact_phone}</p></div>
          </a>
          <a href={`mailto:${s.contact_email}`} className="bg-white rounded-2xl border border-[#EFEBE1] p-6 flex items-center gap-4 hover:-translate-y-1 hover:shadow-lg transition-[transform,box-shadow]">
            <div className="h-12 w-12 rounded-full bg-mutedcream flex items-center justify-center text-goldsoft"><Mail size={22} /></div>
            <div><p className="text-sm text-muted-foreground">Email us</p><p className="font-semibold text-choco break-all">{s.contact_email}</p></div>
          </a>
          <div className="bg-white rounded-2xl border border-[#EFEBE1] p-6 flex items-center gap-4">
            <div className="h-12 w-12 rounded-full bg-mutedcream flex items-center justify-center text-goldsoft"><MapPin size={22} /></div>
            <div><p className="text-sm text-muted-foreground">Visit</p><p className="font-semibold text-choco">{s.contact_address}</p></div>
          </div>
          <a href={s.instagram} target="_blank" rel="noreferrer" className="bg-white rounded-2xl border border-[#EFEBE1] p-6 flex items-center gap-4 hover:-translate-y-1 hover:shadow-lg transition-[transform,box-shadow]">
            <div className="h-12 w-12 rounded-full bg-mutedcream flex items-center justify-center text-goldsoft"><Instagram size={22} /></div>
            <div><p className="text-sm text-muted-foreground">Follow</p><p className="font-semibold text-choco">Instagram</p></div>
          </a>
        </div>
      )}
    </div>
  );
};

export default Contact;
